export const getList = (start: string, source: string) => {
  const query = `SELECT ?startPara ?source ?startTranscription ?sourceTranscription ?elementText ?startLongTitle ?sourceLongTitle ?startAuthorTitle ?sourceAuthorTitle ?elementRef ?elementRefText 
      WHERE {
      ?refquote <http://scta.info/property/structureType> <http://scta.info/resource/structureElement> . 
      ?refquote a <http://scta.info/resource/expression> . 
      ?refquote <http://scta.info/property/isMemberOf> <${start}> .
      {
      ?refquote <http://scta.info/property/source> ?source . 
        OPTIONAL{
          ?source <http://scta.info/property/hasCanonicalManifestation> ?sourceManifestation .
          ?sourceManifestation <http://scta.info/property/hasCanonicalTranscription> ?sourceTranscription .
        }
        OPTIONAL{
          ?refquote <http://scta.info/property/structureElementText> ?elementText
        }
        OPTIONAL{
           ?elementRef <http://scta.info/property/isReferenceTo> ?refquote . 
           ?elementRef <http://scta.info/property/structureElementText> ?elementRefText . 
        }
      }
      UNION
      {
        ?refquote <http://scta.info/property/source> ?bn . 
        ?bn <http://scta.info/property/source> ?source .
        ?source <http://scta.info/property/hasCanonicalManifestation> ?sourceManifestation .
        ?sourceManifestation <http://scta.info/property/hasCanonicalTranscription> ?sourceTranscription .
      }
      ?source <http://scta.info/property/isMemberOf> <${source}> . 
      ?refquote <http://scta.info/property/isPartOfStructureBlock> ?startPara .
        OPTIONAL{
          ?startPara <http://scta.info/property/hasCanonicalManifestation> ?startManifestation .
          ?startManifestation <http://scta.info/property/hasCanonicalTranscription> ?startTranscription .
        }
        OPTIONAL{
          ?refquote <http://scta.info/property/structureElementText> ?elementText
        }
          OPTIONAL{
           ?elementRef <http://scta.info/property/isReferenceTo> ?refquote .
           ?elementRef <http://scta.info/property/structureElementText> ?elementRefText .
        }
      OPTIONAL{
        ?startPara <http://scta.info/property/longTitle> ?startLongTitle .
        ?source <http://scta.info/property/longTitle> ?sourceLongTitle .
        ?startPara <http://scta.info/property/isPartOfTopLevelExpression> ?startTopLevel .
        ?startTopLevel <http://www.loc.gov/loc.terms/relators/AUT> ?startAuthor .
        ?startAuthor <http://purl.org/dc/elements/1.1/title> ?startAuthorTitle .
        ?source <http://scta.info/property/isPartOfTopLevelExpression> ?sourceTopLevel .
        ?sourceTopLevel <http://www.loc.gov/loc.terms/relators/AUT> ?sourceAuthor .
        ?sourceAuthor <http://purl.org/dc/elements/1.1/title> ?sourceAuthorTitle .
        }
      
      }
      LIMIT 20`
      return query
}